import React, {Component} from 'react'
import {message, Modal, Form, DatePicker,Popconfirm} from 'antd'
import {getKtCabinShort, reqKtOptRecord, reqKtRecordSave, reqKtRecordUpdate, reqKtRecordDel} from '../../api';
import {subTimeStr,subStr} from "../../utills/subStringUtill";
import './delivery-step.less'
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

const formItemLayout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 14,
    },
};
class KtDeliveryStep extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: [],
            processShow:false,
            visible: false,
        }
    }

    getOrderShortFunc = async (orderId) => {
        let result = await getKtCabinShort(orderId)
        if (result.code === 200) {
            this.setState({
                destinationCity: '到达' + result.data.destinationCity,
                commitDt: result.data.commitDt,
            })
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {
            message.error(result.message)
        }
    };
    getOptRecord = async (orderId) => {
        const result = await reqKtOptRecord(orderId);
        if (result.code == '200') {
            //状态：collect:揽货,arrive:到达山口,declare:报关,systemPass:海关系统放行,pass:实货放行,transport:转运,dstkArrive:到达多斯特克,
            //     dstkOut:多斯特克出发,destCity:到达目的城市,declareStore:清关仓库,destination:到达目的地)
            const data = {};
            data.collectDt = this.getDt(result.data, 'collect');
            data.arriveDt = this.getDt(result.data, 'arrive');
            data.declareDt = this.getDt(result.data, 'declare');
            data.systemPassDt = this.getDt(result.data, 'systemPass');
            data.passDt = this.getDt(result.data, 'pass');
            data.transportDt = this.getDt(result.data, 'transport');
            data.dstkArriveDt = this.getDt(result.data, 'dstkArrive');
            data.dstkOutDt = this.getDt(result.data, 'dstkOut');
            data.destCityDt = this.getDt(result.data, 'destCity');
            data.declareStoreDt = this.getDt(result.data, 'declareStore');
            data.destinationDt = this.getDt(result.data, 'destination');
            data.arriveMalaDt = this.getDt(result.data, 'arriveMala');
            data.leaveMalaDt = this.getDt(result.data, 'leaveMala');
            data.arriveBrestDt = this.getDt(result.data, 'arriveBrest');
            this.setColletDt(data.collectDt)
            this.setState(data);
        }
    };
    getDt = (data, optType) => {
        let record = data.filter(o => o.optType == optType);
        if (record.length > 0) {
            return record[0].optDt
        }
        return '';
    };
    editDate = (type, optDt) => {
        const {action} = this.props;
        if(action==='edit'){
            if (optDt) {
                this.props.form.setFieldsValue({optDt: moment(optDt, 'YYYY-MM-DD HH:mm:ss')});
            }
            this.setState({
                visible: true,
                type: type,
                action: optDt ? 'update' : 'add',
            });
        }
    };

    handleOk = async (e) => {
        const {type} = this.state;
        const data = this.props.form.getFieldsValue();
        const values = {};
        values.orderId = this.state.orderId;
        values.optType = type;
        values.optDt = moment(data.optDt).format('YYYY-MM-DD HH:mm:ss');
        if (data.optDt) {
            if (this.state.action == 'update') {
                const result = await reqKtRecordUpdate(values);
                if (result.code == '200') {
                    this.setDt(type, values.optDt);
                } else {
                    message.error(result.message);
                }
            } else {
                const result = await reqKtRecordSave(values);
                if (result.code == '201') {
                    this.setDt(type, values.optDt);
                } else {
                    message.error(result.message);
                }
            }
        } else {
            if (this.state.action == 'update') {
                delete values.optDt;
                const result = await reqKtRecordDel(values);
                if (result.code == '200') {
                    this.setDt(type, values.optDt);
                } else {
                    message.error(result.message);
                }
            }
        }
        this.handleCancel();
    };

    handleCancel = e => {
        this.props.form.resetFields();
        this.setState({
            visible: false,
        });
    };

    setDt = (type, optDt) => {
        if (type === 'collect') {
            this.setState({
                collectDt: optDt,
            });
        }else if(type === 'declare'){
            this.setState({
                declareDt: optDt,
            });
        }else if(type === 'systemPass'){
            this.setState({
                systemPassDt: optDt,
            });
        }else if(type === 'arrive'){
            this.setState({
                arriveDt: optDt,
            });
        }else if(type === 'pass'){
            this.setState({
                passDt: optDt,
            });
        }else if(type === 'transport'){
            this.setState({
                transportDt: optDt,
            });
        }else if(type === 'dstkArrive'){
            this.setState({
                dstkArriveDt: optDt,
            });
        }else if(type === 'dstkOut'){
            this.setState({
                dstkOutDt: optDt,
            });
        }else if(type === 'destCity'){
            this.setState({
                destCityDt: optDt,
            });
        }else if(type === 'declareStore'){
            this.setState({
                declareStoreDt: optDt,
            });
        }else if(type === 'destination'){
            this.setState({
                destinationDt: optDt,
            });
        }else if(type === 'arriveMala'){
            this.setState({
                arriveMalaDt: optDt,
            });
        }else if(type === 'leaveMala'){
            this.setState({
                leaveMalaDt: optDt,
            });
        }else if(type === 'arriveBrest'){
            this.setState({
                arriveBrestDt: optDt,
            });
        }
    };

    componentDidMount() {
        let orderId = this.props.location.state.orderId;
        if(!orderId){
            orderId = this.props.location.state.id
        }
        console.log(this.props.location.state)
        this.getOrderShortFunc(orderId);
        this.getOptRecord(orderId);
        this.setState({orderId: orderId});
    }

    setColletDt = (date) =>{
        const {setColletDt} = this.props
        if(setColletDt){
            setColletDt(date)
        }
    }

    spreadOpt = () => {
        const {processShow} = this.state
        if(processShow){
            this.setState({
                processShow:false
            })
        }else{
            this.setState({
                processShow:true
            })
        }
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        const {action} =  this.props;
        const {processShow} = this.state
        return (
            <div className={processShow ? "processBox processShow":'processBox'}>
                <Modal
                    title="轨迹编辑"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}>
                    <Form {...formItemLayout}>
                        <Form.Item label="时间">
                            {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
                        </Form.Item>
                    </Form>
                </Modal>
                <div className={this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                    <div className="info">
                        <div className="circle"><i></i></div>
                        <div className="title">货运订单</div>
                        <div className="time1">{this.state.commitDt ? subStr(this.state.commitDt) :''}</div>
                        <div className="time2">{this.state.commitDt ? subTimeStr(this.state.commitDt) :''}</div>

                    </div>
                </div>
                <div className={this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                    <div className={action==='edit' ?'info itemHover':'info'} onClick={() => this.editDate('collect', this.state.collectDt)}>
                        <div className="circle"><i></i></div>
                        <div className="title">上门提货</div>
                        <div className="time1">{this.state.collectDt? subStr(this.state.collectDt) :''}</div>
                        <div className="time2">{this.state.collectDt? subTimeStr(this.state.collectDt) :''}</div>
                    </div>
                </div>
                <div className={this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                    <div className={action==='edit' ?'info itemHover':'info'} onClick={() => this.editDate('declare', this.state.declareDt)}>
                        <div className="circle"><i></i></div>
                        <div className="title">出口报关</div>
                        <div className="time1">{this.state.declareDt ? subStr(this.state.declareDt) :''}</div>
                        <div className="time2">{this.state.declareDt ? subTimeStr(this.state.declareDt) :''}</div>
                    </div>
                </div>
                <div className={this.state.systemPassDt ? 'proceIteam finish' : 'proceIteam'}>
                    <div className={action==='edit' ?'info itemHover':'info'} onClick={() => this.editDate('systemPass', this.state.systemPassDt)}>
                        <div className="circle"><i></i></div>
                        <div className="title">海关系统放行</div>
                        <div className="time1">{this.state.systemPassDt ? subStr(this.state.systemPassDt) :''}</div>
                        <div className="time2">{this.state.systemPassDt ? subTimeStr(this.state.systemPassDt) :''}</div>
                    </div>
                </div>
                <div className={this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                    <div className={action==='edit' ?'info itemHover':'info'} onClick={() => this.editDate('arrive', this.state.arriveDt)}>
                        <div className="circle"><i></i></div>
                        <div className="title">到达阿拉山口</div>
                        <div className="time1">{this.state.arriveDt ? subStr(this.state.arriveDt) :''}</div>
                        <div className="time2">{this.state.arriveDt ? subTimeStr(this.state.arriveDt) :''}</div>
                    </div>
                </div>

                <div className={this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                    {action === 'edit' ?
                        <Popconfirm title="请确认数据已经完整，放行后则不能修改数据！"
                                    onConfirm={() => this.editDate('pass', this.state.passDt)}>
                            <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                                <div className="circle"><i></i></div>
                                <div className="title">实货放行</div>
                                <div className="time1">{this.state.passDt ? subStr(this.state.passDt):''}</div>
                                <div className="time2">{this.state.passDt ? subTimeStr(this.state.passDt):''}</div>
                            </div>
                        </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">实货放行</div>
                            <div className="time1">{this.state.passDt ? subStr(this.state.passDt):''}</div>
                            <div className="time2">{this.state.passDt ? subTimeStr(this.state.passDt):''}</div>
                        </div>
                    }
                </div>
                <div className={this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                    <div className={action==='edit' ?'info itemHover':'info'} onClick={() => this.editDate('transport', this.state.transportDt)}>
                        <div className="circle"><i></i></div>
                        <div className="title">转运（铁路干线）</div>
                        <div className="time1">{this.state.transportDt ? subStr(this.state.transportDt) :''}</div>
                        <div className="time2">{this.state.transportDt ? subTimeStr(this.state.transportDt) :''}</div>
                    </div>
                </div>
                <div className={this.state.dstkArriveDt ? 'proceIteam finish' : 'proceIteam'}>
                    <div className={action==='edit' ?'info itemHover':'info'} onClick={() => this.editDate('dstkArrive', this.state.dstkArriveDt)}>
                        <div className="circle"><i></i></div>
                        <div className="title">到达多斯特克</div>
                        <div className="time1">{this.state.dstkArriveDt ? subStr(this.state.dstkArriveDt) :''}</div>
                        <div className="time2">{this.state.dstkArriveDt ? subTimeStr(this.state.dstkArriveDt) :''}</div>
                    </div>
                </div>
                <div className={this.state.dstkOutDt ? 'proceIteam finish' : 'proceIteam'}>
                    <div className={action==='edit' ?'info itemHover':'info'} onClick={() => this.editDate('dstkOut', this.state.dstkOutDt)}>
                        <div className="circle"><i></i></div>
                        <div className="title">多斯特克出发</div>
                        <div className="time1">{this.state.dstkOutDt ? subStr(this.state.dstkOutDt) :''}</div>
                        <div className="time2">{this.state.dstkOutDt ? subTimeStr(this.state.dstkOutDt) :''}</div>
                    </div>
                </div>
                <div className={this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                    <div className={action==='edit' ?'info itemHover':'info'} onClick={() => this.editDate('destination', this.state.destinationDt)}>
                        <div className="circle"><i></i></div>
                        <div className="title">抵达目的地</div>
                        <div className="time1">{this.state.destinationDt ? subStr(this.state.destinationDt) :''}</div>
                        <div className="time2">{this.state.destinationDt ? subTimeStr(this.state.destinationDt) :''}</div>
                    </div>
                </div>
                <div className="processShowBtn" onClick={this.spreadOpt}><span className="open">展开</span> <span className="closed">收起</span>
                </div>
            </div>
        )
    }
}
const KtDeliveryStepForm = Form.create()(KtDeliveryStep);
export default KtDeliveryStepForm;